import React from 'react';
import '../../styles/GridBoxes.css';
import testimonial from '../../assets/testimonial.jpg';
import { Link } from 'react-router-dom';

export default function SecondaryBox4 (props) {

  return (
    <div className='box'>
        <h1>{props.SecondaryBoxTitle4}</h1>
        <Link to="/testimonials">
        <img src={testimonial} alt="" />
        </Link>
    </div>
  );
};